'use client'

import React, { useEffect, useState } from 'react'

import { cn } from '@hanzo/ui'
import { Login as IamLogin, useIam } from '@hanzo/iam/react'

import { remember } from './resume'

  /**
   * Sign-in rendered in place, on this site's own domain: IAM mints an
   * authorization code bound to a PKCE challenge and the form navigates to
   * /auth/callback to redeem it. No credential ever reaches this bundle's
   * origin, and there is one sign-in surface rather than one per app.
   */
const Login: React.FC<{
  className?: string
  onSuccess?: (token: string) => void
}> = ({
  className,
  onSuccess
}) => {

  const { config } = useIam()
    /* OIDC anti-CSRF nonce, one per mounted form. */
  const [state] = useState(() => crypto.randomUUID())

    /* Sign-in leaves for /auth/callback, so record the page holding this form to
      come back to. */
  useEffect(remember, [])

  return (
    <IamLogin
      serverUrl={config.serverUrl}
      clientId={config.clientId}
      redirectUri={config.redirectUri}
      organization={config.organization}
      state={state}
        /* Naming a class replaces the view's own, so keep both: the site skins
          .hanzo-iam-* once, in lux-global.css. */
      className={cn('hanzo-iam-card', className)}
      onSuccess={onSuccess}
    />
  )
}

export default Login
